import React from "react";

const Error = () => {
  return (
    <div className="container__content-body">
      <h1>NOT FOUND</h1>
    </div>
  );
};

export default Error;
